module.exports = "/images/sea_grey.png?20aeb9b8a919107dbfb146e38df7bea4";